import setupStore from 'store'
import App from './App'
import rootEpic from './epics'
import rootReducer from './reducers'
const Store = setupStore({
  rootEpic,
  rootReducer,
})
export { App, Store }